export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines/2-66d17e964bf3d6a7b28ab4b794038e6c.svg";